export default __webpack_public_path__ + "static/media/icon_intelligence_naturalistic.ef3580b4.svg";